// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"476":"7b61e1b1","905":"f8f0f7cb"}[chunkId] + ".chunk.js";
};